<template>

  <h1>基础配置</h1>

</template>

<script>
export default {
  name: "index"
};
</script>

<style scoped>

</style>
